import "./StructuralDeckContractors.module.css";
import Header from "@/reusable_sections/Header";
import TheDigitalJobsite from "./sections/TheDigitalJobsite";
import AboutKhakiPlumbing from "./sections/AboutKhakiPlumbing";
import PoliciesCertifications from "./sections/PoliciesCertifications";
import ReadyForAConsultation from "./sections/ReadyForAConsultation";
import Footer from "@/reusable_sections/Footer";
export default function StructuralDeckContractorsPage() {
  return <div>
      <Header />
      <TheDigitalJobsite />
      <AboutKhakiPlumbing />
      <PoliciesCertifications />
      <ReadyForAConsultation />
      <Footer />
    </div>;
}